import { _ } from "../../../../../core/polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import button from "@foretagsplatsen/finsit-design-system/widget-js/elements/button";
import ManualEntryViewer from "../../../../../core/widgets/ManualEntryViewer/ManualEntryViewer.js";
import OwnRuleTemplateModel from "../RuleTemplatesWidget/RuleTemplateModel/OwnRuleTemplateModel.js";

/**
 * Widget to display a list of manual entries.
 * All manual entries of this list can be collapsed or extended.
 *
 * @param {RuleTemplateModel[]} ruleTemplateModels - Model to pilot this widget
 * @param {function} onDelete - Callback invoked when "Delete" is clicked
 * @param {boolean} [readOnly] - Whether the actions must be hidden or not
 */
export default class ManualEntryRuleTemplateCollectionWidget extends Widget {
	constructor({
		ruleTemplateModels,
		onDelete = () => {},
		onEdit = () => {},
		readOnly = false,
	}) {
		super(...arguments);

		this._onDelete = onDelete;
		this._onEdit = onEdit;
		this._readOnly = readOnly;

		this._ruleTemplateModels = ruleTemplateModels.map(
			(ruleTemplate) => new OwnRuleTemplateModel({ ruleTemplate }),
		);
	}

	renderContentOn(html) {
		if (!this._ruleTemplateModels.length) {
			return;
		}

		const viewers = this._makeViewers();

		html.div(
			{ class: "manual-journal-entry-viewers" },
			html.div(
				{ class: "viewers-actions" },
				button(
					{
						link: true,
						dataTest: "collapse-all",
						onClick: () =>
							viewers.forEach((viewer) => viewer.collapse()),
					},
					_("Collapse all"),
				),
				button(
					{
						link: true,
						dataTest: "expand-all",
						onClick: () =>
							viewers.forEach((viewer) => viewer.expand()),
					},
					_("Expand all"),
				),
			),
			viewers,
		);
	}

	_makeViewers() {
		return this._ruleTemplateModels.map(
			(ruleTemplate) =>
				new ManualEntryViewer({
					manualEntryRuleModel: ruleTemplate
						.getRuleTemplate()
						.getRuleModel(),
					onDelete: () => this._onDelete({ ruleTemplate }),
					onEdit: () => this._onEdit({ ruleTemplate }),
					readOnly: this._readOnly,
				}),
		);
	}
}
